exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "p[data-v-11a50349]{font-size:20px;line-height:20px;color:#6d6d6d;padding:65px 0}.container[data-v-11a50349]{overflow:hidden;padding-bottom:90px}", ""]);

